import { Component, Input } from '@angular/core';
import { CupcakePopoverOptions } from '@ipreo/cupcake-components';

@Component({
  selector: 'muni-gameday-comment',
  templateUrl: './comment.template.html',
  styleUrls: ['./comment.styles.scss']
})
export class CommentComponent {
  @Input()
  public text: string;
  public get popover() {
    return new CupcakePopoverOptions({
      trigger: 'click',
      text: `${this.text}`,
      position: 'right'
    });
  }
}
